import { NonSerializedInventory } from '../../../proto/generated/inv_non_serialized_inventory_message_pb';
import { NonSerializedAdjustmentNoteModel } from './non-serialized-adjustment-note.model';
import { NonSerializedInventoryLocationModel } from './non-serialized-inventory-location.model';

export class NonSerializedInventoryModel {
  name: string;
  item: string;
  quantity: number;
  unit: string;
  description: string;
  contractName: string;
  contractTitle?: string;
  lowStockThreshold?: number;
  locations: NonSerializedInventoryLocationModel[];
  adjustmentNotes?: NonSerializedAdjustmentNoteModel[];

  static MapperList(source: NonSerializedInventory[]): NonSerializedInventoryModel[] {
    const list: NonSerializedInventoryModel[] = [];
    source?.forEach((element) => {
      list.push(NonSerializedInventoryModel.Mapper(element));
    });
    return list;
  }

  static Mapper(source: NonSerializedInventory): NonSerializedInventoryModel {
    const destination = new NonSerializedInventoryModel();

    if (source != null) {
      destination.name = source.getName();
      destination.contractName = source.getContractName();
      destination.item = source.getItem();
      destination.quantity = source.getQuantity();
      destination.unit = source.getUnit();
      destination.description = source.getDescription();
      destination.contractTitle = source.getContractTitle();
      destination.lowStockThreshold = source.getLowStockThreshold();
      destination.adjustmentNotes = NonSerializedAdjustmentNoteModel.MapperList(
        source.getAdjustmentNotesList()
      );
      destination.locations = NonSerializedInventoryLocationModel.MapperList(
        source.getLocationsList()
      );
    }

    return destination;
  }

  static MapperProto(source: NonSerializedInventoryModel): NonSerializedInventory {
    const destination = new NonSerializedInventory();

    if (source != null) {
      destination.setName(source.name || '');
      destination.setItem(source.item);
      destination.setQuantity(source.quantity);
      destination.setUnit(source.unit);
      destination.setDescription(source.description);
      destination.setContractName(source.contractName || '');
      destination.setContractTitle(source.contractTitle || '');
      destination.setLowStockThreshold(source.lowStockThreshold ?? 0);
      destination.setAdjustmentNotesList(
        (source.adjustmentNotes || []).map((adjustmentNote) =>
          NonSerializedAdjustmentNoteModel.MapperProto(adjustmentNote)
        )
      );
      destination.setLocationsList(
        (source.locations || []).map((location) =>
          NonSerializedInventoryLocationModel.MapperProto(location)
        )
      );
    }

    return destination;
  }
}
